export const SET_ADM_DATA_MANAGEMENT_LOADING = "SET_ADM_DATA_MANAGEMENT_LOADING"
export const SET_ADM_DATA_MANAGEMENT_SUCCESS = "SET_ADM_DATA_MANAGEMENT_SUCCESS"
export const SET_ADM_DATA_MANAGEMENT_ERROR = "SET_ADM_DATA_MANAGEMENT_ERROR"
export const SET_ADM_DATA_MANAGEMENT_RESULT = "SET_ADM_DATA_MANAGEMENT_RESULT"

export const GET_DB_CAPACITY_INFO = "GET_DB_CAPACITY_INFO"
export const GET_DB_CAPACITY_INFO_SUCCESS = "GET_DB_CAPACITY_INFO_SUCCESS"

export const GET_MADRID_CRAWL_INFO = "GET_MADRID_CRAWL_INFO"
export const GET_MADRID_CRAWL_INFO_SUCCESS = "GET_MADRID_CRAWL_INFO_SUCCESS"

export const GET_HAGUE_CRAWL_INFO = "GET_HAGUE_CRAWL_INFO"
export const GET_HAGUE_CRAWL_INFO_SUCCESS = "GET_HAGUE_CRAWL_INFO_SUCCESS"

export const GET_PCT_CRAWL_INFO = "GET_PCT_CRAWL_INFO"
export const GET_PCT_CRAWL_INFO_SUCCESS = "GET_PCT_CRAWL_INFO_SUCCESS"

export const GET_MADRID_PDF_ERROR_INFO = "GET_MADRID_PDF_ERROR_INFO"
export const GET_MADRID_PDF_ERROR_INFO_SUCCESS = "GET_MADRID_PDF_ERROR_INFO_SUCCESS"
export const CHANGE_MADRID_PDF_ERROR_INFO = "CHANGE_MADRID_PDF_ERROR_INFO"
export const SAVE_MADRID_PDF_ERROR_INFO = "SAVE_MADRID_PDF_ERROR_INFO"
export const SAVE_MADRID_PDF_ERROR_INFO_SUCCESS = "SAVE_MADRID_PDF_ERROR_INFO_SUCCESS"

export const GET_MADRID_DISCREPENCY_INFO = "GET_MADRID_DISCREPENCY_INFO"
export const GET_MADRID_DISCREPENCY_INFO_SUCCESS = "GET_MADRID_DISCREPENCY_INFO_SUCCESS"

export const GET_SERVERS_INFO = "GET_SERVERS_INFO"
export const GET_SERVERS_INFO_SUCCESS = "GET_SERVERS_INFO_SUCCESS"

export const GET_EMAIL_SERVER_INFO = "GET_EMAIL_SERVER_INFO"
export const GET_EMAIL_SERVER_INFO_SUCCESS = "GET_EMAIL_SERVER_INFO_SUCCESS"
export const CHANGE_EMAIL_SERVER_INFO = "CHANGE_EMAIL_SERVER_INFO"
export const SAVE_EMAIL_SERVER_INFO = "SAVE_EMAIL_SERVER_INFO"
export const SAVE_EMAIL_SERVER_INFO_SUCCESS = "SAVE_EMAIL_SERVER_INFO_SUCCESS"

export const GET_BACKUP_INFO = "GET_BACKUP_INFO"
export const GET_BACKUP_INFO_SUCCESS = "GET_BACKUP_INFO_SUCCESS"
export const CHANGE_BACKUP_INFO = "CHANGE_BACKUP_INFO"
export const SAVE_BACKUP_INFO = "SAVE_BACKUP_INFO"
export const SAVE_BACKUP_INFO_SUCCESS = "SAVE_BACKUP_INFO_SUCCESS"

export const GET_REMAINING_INFO = "GET_REMAINING_INFO"
export const GET_REMAINING_INFO_SUCCESS = "GET_REMAINING_INFO_SUCCESS"

export const GET_ROMARIAN_INFO = "GET_ROMARIAN_INFO"
export const GET_ROMARIAN_INFO_SUCCESS = "GET_ROMARIAN_INFO_SUCCESS"
